/*global $, alertify */

/**
 * Файл с обработкой заполнения анкеты по ИНН
 */

"use strict";

// Инициализация масок на поля
function initInputMasks() {
    // Маска на поле даты + календарик
    // Дата выдачи паспорта
    // Дата рождения
    $(".js-mask-calendar")
        .datetimepicker({
            locale: "ru",
            format: "DD.MM.YYYY",
            useCurrent: false,
        })
        .val(function (i, value) {
            return value === "01.01.0001" ? "" : value;
        })
        .inputmask("99.99.9999", { insertMode: false });

    // Маска на поле даты + календарик в европейском формате
    // Дата выдачи паспорта
    // Дата рождения
    $(".js-euro-mask-calendar")
        .datetimepicker({
            locale: "ru",
            format: "MM/DD/YYYY",
            useCurrent: false,
        })
        .val(function (i, value) {
            return value === "01/01/0001" ? "" : value;
        })
        .inputmask("99/99/9999", { insertMode: false });

    // СНИЛС
    $('[name$="SNILS"]').inputmask("999-999-999-99");
    $('[name*="Snils"]').inputmask("999-999-999-99");

    $(".js-mask-snils").inputmask("999-999-999-99");

    // Серия паспорта гражданина РФ
    $(".js-mask-passport-series").inputmask({
        mask: "9999",
        autoUnmask: true,
    });

    // Номер паспорта гражданина РФ
    $(".js-mask-passport-number").inputmask({
        mask: "999999",
        autoUnmask: true,
    });

    // Серия и номер паспорта для иностранного гражданина
    // может использоваться буквенно-цифровое значение
    $(".js-mask-is-foreigner").inputmask({
        mask: "*",
        repeat: 32,
        autoUnmask: true,
    });

    // КПП
    $(".js-mask-kpp").inputmask({
        mask: "9",
        repeat: 9,
    });

    // Телефон
    $('[name$=".Phone"]').val(function (index, value) {
        return value === "" ? "+7" : value;
    });

    $('[name$=".Phone"]').inputmask("+99999999999");

    // ОГРН
    $(".js-mask-ogrn").inputmask({
        mask: "9",
        repeat: 13,
    });

    // ОГРНИП
    $(".js-mask-ogrnip").inputmask({
        mask: "9",
        repeat: 15,
    });

    // Паспорт. Код подразделения
    $(".js-mask-passport-issueid").inputmask({
        mask: "999-999",
        autoUnmask: true,
    });

    // ИНН (12 символов)
    $(".js-mask-inn").inputmask({
        mask: "999999999999",
        autoUnmask: true,
    });

    // ИНН (10 и 12 символов)
    $(".js-mask-inn-common").inputmask({
        mask: "(9999999999)|(999999999999)",
        autoUnmask: true,
    });

    // ИНН (10 символов юр.лица)
    $(".js-mask-inn-legal").inputmask({
        mask: "9999999999",
        autoUnmask: true,
        oncomplete: function () {
            var inn = this.value;
            getEGRNdata(inn);
        },
    });

    // ИНН (12 символов ИП)
    $(".js-mask-inn-ip").inputmask({
        mask: "999999999999",
        autoUnmask: true,
        oncomplete: function () {
            var inn = this.value;
            getEGRNdata(inn);
        },
    });

    // Кодовое слово (12 символов)
    $(".js-mask-alias").inputmask({
        mask: "*",
        repeat: 12,
        autoUnmask: true,
    });
}

// Инициализация полей анкеты
function initClientAnketa() {
    if ($(".js-select-citizenShip").val() === "RUS") {
        $(".fms-unit-passport-issued").attr(
            "oninput",
            "this.value = this.value.replace(/[^0-9А-Яа-яЁё., \\-\\/:()№*\"]/g, '')"
        );
    } else {
        $(".fms-unit-passport-issued").attr(
            "oninput",
            "this.value = this.value.replace(/[^0-9A-Za-zА-Яа-яЁё., \\-\\/:()№*\"]/g, '')"
        );
    }

    //////////////////////
    // Маски на поля ввода
    initInputMasks();

    // Скрываем не обязательные поля в анкете руководителя
    $(".js-hide-form-group").addClass("hidden");

    // Если клиент был создан с ИНН
    // предзаполняем поля автоматически
    var prefilledINN = window.INN;
    if (prefilledINN && prefilledINN.length) {
        prefilledINN.length === 10 && setInnForSelector("#ЮЛ", prefilledINN);
        prefilledINN.length === 12 && setInnForSelector("#ИП", prefilledINN);
    }

    // Копирование полей юр адреса в поля факт адреса
    $(".copyAddressInput").on("input change", function () {
        var $this = $(this);

        var isChecked = $("#copyAddress").is(":checked");
        var $id = $this.attr("id");

        if (
            isChecked &&
            ($id != "RegionRowId" ||
                $id != "ProfileDifference_RegionRowId_Value")
        ) {
            var targetId = $this.attr("data-address");
            $("#" + targetId).val($this.val());
        }
    });

    // Копирование значения с Региона юридического в фактический
    $("#RegionRowId").on("change", function () {
        var $this = $(this);
        var val = $("#RegionRowId option:selected").val();

        var isChecked = $("#copyAddress").is(":checked");

        if (isChecked && val != "") {
            var value = $("#RegionRowId option:selected").text();
            var targetId = $this.attr("data-address");
            $("#" + targetId).val(value);
        } else {
            $("#FactAddressModel_Region").val("");
        }
    });

    // Копирование значения с Региона юридического в фактический Инженера УЦ
    $("#ProfileDifference_RegionRowId_Value").on("change", function () {
        var $this = $(this);
        var val = $(
            "#ProfileDifference_RegionRowId_Value option:selected"
        ).val();

        var isChecked = $("#copyAddress").is(":checked");

        if (isChecked && val != "") {
            var value = $(
                "#ProfileDifference_RegionRowId_Value option:selected"
            ).text();
            var targetId = $this.attr("data-address");
            $("#" + targetId).val(value);
        } else {
            $("#FactAddressModel_Region").val("");
        }
    });

    // Копирование значение регион
    $("#copyAddress").on("change", function () {
        var val =
            $("#RegionRowId option:selected").val() ||
            $("#ProfileDifference_RegionRowId_Value option:selected").val();
        var text =
            $("#RegionRowId option:selected").text() ||
            $("#ProfileDifference_RegionRowId_Value option:selected").text();

        var isChecked = $("#copyAddress").is(":checked");

        if (isChecked && val != "") {
            $("#FactAddressModel_Region").val(text);
            $("#ProfileDifference_FactAddress_Region_Value").val(text);
        }
    });

    // Копирование полей ответственного владельца СКЗИ в поля директора, для  юр.лица
    // Событие change необходимо для отслеживания изменений в <select>
    // Событие dp.change необходимо для отслеживания изменений календаря
    $(".copyHolderSkziInput").on("input change dp.change", function () {
        var $this = $(this);

        var isCheckedToDirector = $("#copyToDirectorData").is(":checked");

        if (isCheckedToDirector) {
            var targetFieldId = $this.attr("data-holder");
            if ($this.is(":checkbox")) {
                $("#" + targetFieldId).prop("checked", $this.is(":checked"));
            } else {
                $("#" + targetFieldId).val($this.val());
            }
        }
    });

    // Копирование полей ответственного владельца СКЗИ в поля директора, для  ИП
    // Событие change необходимо для отслеживания изменений в <select>
    // Событие dp.change необходимо для отслеживания изменений календаря
    $(".copyHolderSkziInputToIP").on("input change dp.change", function () {
        var $this = $(this);

        var isCheckedToIpPersonal = $("#copyToIpPersonalData").is(":checked");

        if (isCheckedToIpPersonal) {
            var targetFieldId = $this.attr("data-holder");
            if ($this.is(":checkbox")) {
                $("#" + targetFieldId).prop("checked", $this.is(":checked"));
            } else {
                $("#" + targetFieldId).val($this.val());
            }
        }
    });

    // Запрет на ввод специальных символов
    $(".js-delete-symbol").on("input change dp.change", function () {
        var $this = $(this);
        $this.val($this.val().replace(";", ""));
    });

    // Значение по умолчанию у руководителя, если checkbox не отмечен
    // для ИП
    $("#copyToIpPersonalData").click(function () {
        if (
            !$(this).is(":checked") &&
            !$("#IpPersonalData_CitizenShip").prop("disabled")
        ) {
            $('#IpPersonalData_CitizenShip option:contains("РОССИЯ")').prop(
                "selected",
                true
            );
        }
    });

    // для Юр. лица
    $("#copyToDirectorData").click(function () {
        if (
            !$(this).is(":checked") &&
            !$("#DirectorPersonalData_CitizenShip").prop("disabled")
        ) {
            $(
                '#DirectorPersonalData_CitizenShip option:contains("РОССИЯ")'
            ).prop("selected", true);
        }
    });

    // Копируем каждое поле владельца сертификата в поле руководителя для юр. лица
    var copyHolderSkziPersonalDataToDirector = function () {
        setFieldValues({
            directorINN: "#holderINN",
            "#DirectorPersonalData_Position":
                "#HolderSkziPersonalData_Position",
            "#DirectorPersonalData_SubUnit": "#HolderSkziPersonalData_SubUnit",
            "#DirectorPersonalData_ReasonAuthority":
                "#HolderSkziPersonalData_ReasonAuthority",
            "#DirectorPersonalData_Surname": "#HolderSkziPersonalData_Surname",
            "#DirectorPersonalData_Name": "#HolderSkziPersonalData_Name",
            "#DirectorPersonalData_Patronymic":
                "#HolderSkziPersonalData_Patronymic",
            "#DirectorPersonalData_Gender": "#HolderSkziPersonalData_Gender",
            "#DirectorPersonalData_BirthDate":
                "#HolderSkziPersonalData_BirthDate",
            "#DirectorPersonalData_BirthPlace":
                "#HolderSkziPersonalData_BirthPlace",
            "#DirectorPersonalData_SNILS": "#HolderSkziPersonalData_SNILS",
            "#DirectorPersonalData_Passport_Series":
                "#HolderSkziPersonalData_Passport_Series",
            "#DirectorPersonalData_Passport_Number":
                "#HolderSkziPersonalData_Passport_Number",
            "#DirectorPersonalData_Passport_DateOfIssue":
                "#HolderSkziPersonalData_Passport_DateOfIssue",
            "#DirectorPersonalData_Passport_IssueId":
                "#HolderSkziPersonalData_Passport_IssueId",
            "#DirectorPersonalData_Passport_Issued":
                "#HolderSkziPersonalData_Passport_Issued",
            "#DirectorPersonalData_CitizenShip":
                "HolderSkziPersonalData_CitizenShip",
            "#DirectorPersonalData_Passport_DateOfExpiry":
                "#HolderSkziPersonalData_Passport_DateOfExpiry",

            "#ProfileDifference_HeadOfOrganization_Surname_Value":
                "#ProfileDifference_CertificateHolder_Surname_Value",
            "#ProfileDifference_HeadOfOrganization_Name_Value":
                "#ProfileDifference_CertificateHolder_Name_Value",
            "#ProfileDifference_HeadOfOrganization_Patronymic_Value":
                "#ProfileDifference_CertificateHolder_Patronymic_Value",
            "#ProfileDifference_HeadOfOrganization_Employee_Position_Value":
                "#ProfileDifference_CertificateHolder_Employee_Position_Value",
            "#ProfileDifference_HeadOfOrganization_Employee_Unit_Value":
                "#ProfileDifference_CertificateHolder_Employee_Unit_Value",
            "#ProfileDifference_HeadOfOrganization_Employee_Authority_Value":
                "#ProfileDifference_CertificateHolder_Employee_Authority_Value",

            // Копируем чекбокс "Не склонять"
            "#DirectorPersonalData_NotInclineSurname":
                "#HolderSkziPersonalData_NotInclineSurname",
            "#ProfileDifference_HeadOfOrganization_NotInclineSurname_Value":
                "#ProfileDifference_CertificateHolder_NotInclineSurname_Value",
        });
    };

    // Копируем каждое поле владельца сертификата в поле руководителя для ИП
    var copyHolderSkziPersonalDataToIpPersonal = function () {
        setFieldValues({
            "#IpPersonalData_Position": "#HolderSkziPersonalData_Position",
            "#IpPersonalData_ReasonAuthority":
                "#HolderSkziPersonalData_ReasonAuthority",
            "#IpPersonalData_Surname": "#HolderSkziPersonalData_Surname",
            "#IpPersonalData_Name": "#HolderSkziPersonalData_Name",
            "#IpPersonalData_Patronymic": "#HolderSkziPersonalData_Patronymic",
            "#IpPersonalData_Gender": "#HolderSkziPersonalData_Gender",
            "#IpPersonalData_BirthDate": "#HolderSkziPersonalData_BirthDate",
            "#IpPersonalData_BirthPlace": "#HolderSkziPersonalData_BirthPlace",
            "#IpPersonalData_SNILS": "#HolderSkziPersonalData_SNILS",
            "#IpPersonalData_Passport_Series":
                "#HolderSkziPersonalData_Passport_Series",
            "#IpPersonalData_Passport_Number":
                "#HolderSkziPersonalData_Passport_Number",
            "#IpPersonalData_Passport_DateOfIssue":
                "#HolderSkziPersonalData_Passport_DateOfIssue",
            "#IpPersonalData_Passport_IssueId":
                "#HolderSkziPersonalData_Passport_IssueId",
            "#IpPersonalData_Passport_Issued":
                "#HolderSkziPersonalData_Passport_Issued",
            "#IpPersonalData_CitizenShip": "HolderSkziPersonalData_CitizenShip",
            "#IpPersonalData_Passport_DateOfExpiry":
                "#HolderSkziPersonalData_Passport_DateOfExpiry",
            "#ProfileDifference_HeadOfOrganization_Surname_Value":
                "#ProfileDifference_CertificateHolder_Surname_Value",
            "#ProfileDifference_HeadOfOrganization_Name_Value":
                "#ProfileDifference_CertificateHolder_Name_Value",
            "#ProfileDifference_HeadOfOrganization_Patronymic_Value":
                "#ProfileDifference_CertificateHolder_Patronymic_Value",
            "#ProfileDifference_HeadOfOrganization_Employee_Position_Value":
                "#ProfileDifference_CertificateHolder_Employee_Position_Value",
            "#ProfileDifference_HeadOfOrganization_Employee_Unit_Value":
                "#ProfileDifference_CertificateHolder_Employee_Unit_Value",
            "#ProfileDifference_HeadOfOrganization_Employee_Authority_Value":
                "#ProfileDifference_CertificateHolder_Employee_Authority_Value",

            // Копируем чекбокс "Не склонять"
            "#IpPersonalData_NotInclineSurname":
                "#HolderSkziPersonalData_NotInclineSurname",
        });
    };

    // Копируем каждое поле юридического адреса в поля фактического адреса
    var copyLegalAddressToFactAddress = function () {
        setFieldValues({
            "#FactAddressModel_Country": "#UrAddressModel_Country",
            "#FactAddressModel_Locality": "#UrAddressModel_Locality",
            "#FactAddressModel_Address1": "#UrAddressModel_Address1",
            "#ProfileDifference_FactAddress_Country_Value":
                "#ProfileDifference_LegalAddress_Country_Value",
            "#ProfileDifference_FactAddress_Locality_Value":
                "#ProfileDifference_LegalAddress_Locality_Value",
            "#ProfileDifference_FactAddress_Address_Value":
                "#ProfileDifference_LegalAddress_Address_Value",
        });
    };

    ////////////////////////////////////////////////////////////////////////////////////////
    // Используется для скрытия/отображения секций полей + копирование данных через callback
    // Для копирования адресов, персональных данных анкет
    var showOrHideForCopyFields = function (
        sectionSelector,
        checkboxSelector,
        callback
    ) {
        var isChecked = $(checkboxSelector).is(":checked");
        if (isChecked) {
            $(sectionSelector).hide();
            if (callback) {
                callback();
            }
        } else {
            $(sectionSelector).show();
        }
    };

    // Обработка видимости полей факт адреса от чекбокса
    showOrHideForCopyFields("#fact-data", "#copyAddress");
    $("#copyAddress").on("change", function () {
        showOrHideForCopyFields(
            "#fact-data",
            "#copyAddress",
            copyLegalAddressToFactAddress
        );
    });

    // Обработка видимости полей руководителя организации от чекбокса для юр. лица
    showOrHideForCopyFields(".director-data", "#copyToDirectorData");
    $("#copyToDirectorData").on("change", function () {
        showOrHideForCopyFields(
            ".director-data",
            "#copyToDirectorData",
            copyHolderSkziPersonalDataToDirector
        );
    });

    // Обработка видимости полей руководителя организации от чекбокса для ИП
    showOrHideForCopyFields(".ipPersonal-data", "#copyToIpPersonalData");
    $("#copyToIpPersonalData").on("change", function () {
        showOrHideForCopyFields(
            ".ipPersonal-data",
            "#copyToIpPersonalData",
            copyHolderSkziPersonalDataToIpPersonal
        );
    });

    // Обработка видимости всех полей
    showOrHideForCopyFields(
        "#fact-data",
        "#copyAddress",
        copyLegalAddressToFactAddress
    );
    showOrHideForCopyFields(
        ".director-data",
        "#copyToDirectorData",
        copyHolderSkziPersonalDataToDirector
    );
    showOrHideForCopyFields(
        ".ipPersonal-data",
        "#copyToIpPersonalData",
        copyHolderSkziPersonalDataToIpPersonal
    );

    /////////////////////////////////////////////////////////////////
    // Используется для скрытия полей банковских реквизитов
    var showOrHideBankInfo = function (sectionSelector, checkboxSelector) {
        $(sectionSelector).hide();
        // Если скрыты поля то они не должны быть обязательными
        var $BankFields = $(
            "#BankDetails_Bank, #BankDetails_Bic, #BankDetails_CheckingAccount, #BankDetails_CorrespondentAccount"
        );
        $BankFields.prop("required", false);
    };

    // Обработка видимости полей банковских реквизитов только для ип
    showOrHideBankInfo("#ExistBankDetails-data", "#ExistBankDetails");
    $("#ExistBankDetails").on("change", function () {
        showOrHideBankInfo("#ExistBankDetails-data", "#ExistBankDetails");
    });

    // ########################################
    // Логика сохранения форм в профиле клиента

    // Поиск форм внутри профиля клиента
    $("#clientProfile .tab-pane").each(function () {
        var $form = $(this).find("form");

        // Флаг того, что форма изменилась
        var changed = false;

        // Если форма изменилась сохраняем статус
        $form.on("change", function () {
            changed = true;
        });

        // Кастомные правила для валидатора...
        $.validator.addMethod(
            "latinic",
            function (value, element) {
                return (
                    this.optional(element) ||
                    /^[0-9А-Яа-яЁё., \-\/:()№*/""]+$/.test(value)
                );
            },
            "Нельзя использовать латинские символы"
        );

        // Правило валидации: запрет на использование символа " ; "
        $.validator.addMethod(
            "semicolon",
            function (value, element) {
                return (
                    this.optional(element) ||
                    /^[0-9А-Яа-яЁёA-Za-z., \-\/:()№*/""]+$/.test(value)
                );
            },
            'Нельзя использовать следующие символы "! @ # $ % & _ ;" '
        );

        // Правило валидации серии и номера паспорта для иностранных граждан
        $.validator.addMethod(
            "foreign",
            function (value, element) {
                return (
                    this.optional(element) ||
                    /^(?!^0+$)[a-zA-Z0-9]{1,30}$/.test(value)
                );
            },
            "Можно использовать только цифры и латинские символы"
        );

        // Правило валидации номера мобильного телефона
        $.validator.addMethod(
            "phone",
            function (value, element) {
                return (
                    this.optional(element) ||
                    /^[\+]?[0-9]{1}[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/.test(
                        value
                    )
                );
            },
            'Номер должен содержать 11 цифр и может начинаться с "+"'
        );

        // Правило валидации даты выдачи
        $.validator.addMethod(
            "issue",
            function (value, element) {
                var dateBrith = $(".date-brith").val();
                var date1 = dateBrith.split(" ")[0].split(".");
                var date2 = value.split(" ")[0].split(".");

                var dateBrith = Date.parse(
                    date1[2] + "-" + date1[1] + "-" + date1[0]
                );
                var dateOfIssue = Date.parse(
                    date2[2] + "-" + date2[1] + "-" + date2[0]
                );

                return this.optional(element) || dateBrith < dateOfIssue;
            },
            "Дата выдачи не может быть меньше даты рождения"
        );

        // Валидация кода подразделения
        $.validator.addMethod(
            "issueid",
            function (value, element) {
                return this.optional(element) || /^(\d{6})/g.test(value);
            },
            "Введен неправильный код подразделения"
        );

        // Валидация поля алиас
        $.validator.addMethod(
            "alias",
            function (value, element) {
                return (
                    this.optional(element) || /^[0-9a-zA-Z]{12}$/g.test(value)
                );
            },
            "Введен неправильный алиас"
        );

        // Сохранение формы через ajax. Ну и валидация
        $form.validate({
            rules: {
                messages: {
                    name: "Поле Имя не должно быть пустым",
                },
            },
            submitHandler: function (form) {
                let aliasValue = $(".js-mask-alias").val();
                let flagSaveAnketa = true;

                if (typeof globalThis.isAllowedSaveRequest === "undefined") {
                    flagSaveAnketa = true;
                } else {
                    flagSaveAnketa = globalThis.isAllowedSaveRequest;
                }
                if ($("#owner").hasClass("active") && globalThis.canSetDss2Fa)
                    $.ajax({
                        method: "POST",
                        url: globalThis.setDss2FaUrl,
                        contentType: "application/json",
                        data: JSON.stringify({
                            Dss2Fa: 2,
                            Alias: aliasValue,
                        }),
                    })
                        .then(() => {
                            if (!globalThis.isAllowedSaveRequest) {
                                alertify.success("Данные успешно сохранены");
                            }
                        })
                        .catch((error) => {
                            let message = sepErrors(error?.responseJSON);
                            alertify.error(message);
                        });

                if (flagSaveAnketa)
                    $(form).ajaxSubmit({
                        beforeSubmit: function (arr) {
                            showBusyIndicator("Сохранение анкеты");
                            changed = false;
                        },
                        success: function (response) {
                            if (globalThis.canSetIdentificationPoint)
                                globalThis.canSetIdentificationPoint();

                            // если сохраняется массив полей
                            if (Array.isArray(response)) {
                                if (response.length !== 0) {
                                    response.forEach(function (message) {
                                        alertify.error(message);
                                    });
                                }
                                // если ошибок не было, то пришел пустой массив
                                else {
                                    alertify.success("Сохранено");
                                }
                            }
                            // если сохраняется простое поле
                            else {
                                alertify.success("Сохранено");
                            }
                        },
                        error: function (error) {
                            var err = "Ошибка сохранения";
                            if (error?.responseJSON?.message)
                                err = error.responseJSON.message;
                            alertify.error(err);
                        },
                        complete: function () {
                            hideBusyIndicator();
                        },
                    });
            },
        });

        var isForeignCitizen = {
            // Выбранная страна владельца сертификата
            selectHolderSkzi: $("#HolderSkziPersonalData_CitizenShip").val(),

            // Выбранная страна руководителя (Юр. лицо)
            selectDirector: $("#DirectorPersonalData_CitizenShip").val(),

            // Выбранная страна руководителя (ИП)
            selectIp: $("#IpPersonalData_CitizenShip").val(),

            // Выбранная страна физ. лица
            selectFiz: $("#FizPersonalData_CitizenShip").val(),

            // Выбранная страна руководителя (Юр. лицо) УЦ
            selectHolderUC: $(
                "#ProfileDifference_CertificateHolder_Passport_CitizenShip_Value"
            ).val(),

            // Выбранная страна руководителя (ИП) УЦ
            selectIpUC: $(
                "#ProfileDifference_HeadOfOrganization_Passport_CitizenShip_Value"
            ).val(),

            // Признак того, что владелец сертификата является руководителем (Юр. лицо)
            isCheckedToDirector: $("#copyToDirectorData").is(":checked"),

            // Признак того, что владелец сертификата является руководителем (ИП)
            isCheckedToIpPersonal: $("#copyToIpPersonalData").is(":checked"),
        };

        // Обновляем свойства формы заполнения персональными данными
        UpdateFormPersonalData(isForeignCitizen);

        // При изменения гражданства изменяем анкету владельца сертификата
        $(".js-select-citizenShip").on("change", function () {
            var isForeignCitizen = {
                // Выбранная страна владельца сертификата
                selectHolderSkzi: $(
                    "#HolderSkziPersonalData_CitizenShip"
                ).val(),

                // Выбранная страна руководителя (Юр. лицо)
                selectDirector: $("#DirectorPersonalData_CitizenShip").val(),

                // Выбранная страна руководителя (ИП)
                selectIp: $("#IpPersonalData_CitizenShip").val(),

                // Выбранная страна физ. лица
                selectFiz: $("#FizPersonalData_CitizenShip").val(),

                // Выбранная страна руководителя (Юр. лицо) УЦ
                selectHolderUC: $(
                    "#ProfileDifference_CertificateHolder_Passport_CitizenShip_Value"
                ).val(),

                // Выбранная страна руководителя (ИП) УЦ
                selectIpUC: $(
                    "#ProfileDifference_HeadOfOrganization_Passport_CitizenShip_Value"
                ).val(),

                // Признак того, что владелец сертификата является руководителем (Юр. лицо)
                isCheckedToDirector: $("#copyToDirectorData").is(":checked"),

                // Признак того, что владелец сертификата является руководителем (ИП)
                isCheckedToIpPersonal: $("#copyToIpPersonalData").is(
                    ":checked"
                ),
            };

            if ($(this).val() === "RUS") {
                $(".fms-unit-passport-issued").attr(
                    "onkeyup",
                    "limitInput( 'ru', this )"
                );
            } else {
                $(".fms-unit-passport-issued").removeAttr("onkeyup");
            }

            // Обновляем свойства формы заполнения персональными данными
            UpdateFormPersonalData(isForeignCitizen);
        });

        // Вспомогательные функции для валидации полей серии и номера паспорта.
        function ForeignValidationsAttributs(serial, number) {
            //добавляем атрибут для валидации
            $(serial).attr("data-rule-foreign", true);
            $(number).attr("data-rule-foreign", true);

            // Меняем атрибуты валидации
            $(serial).attr("minlength", "2");
            $(number).attr("minlength", "1");

            // Уиничтожаем плейсхолдеры на серию и номер паспорта
            $(serial).attr("placeholder", "");
            $(number).attr("placeholder", "");
        }
        function NotForeignValidationsAttributs(serial, number) {
            // Устанавливаем атрибут для валидации серии и номера паспорта российского гражданина
            $(serial).attr("minlength", "4");
            $(number).attr("minlength", "6");

            // Уничтожаем атрибут для валидации
            $(serial).attr("data-rule-foreign", false);
            $(number).attr("data-rule-foreign", false);

            // Устанавливаем плейсхолдеры на серию и номер паспорта
            $(serial).attr("placeholder", "1234");
            $(number).attr("placeholder", "123456");
        }

        // Изменяем форму сохранения персональных данных,
        // для иностранца владельца сертификата
        function ForeignerHolderSkzi() {
            // Меняем маски на серию и номер паспорта
            $(
                "#HolderSkziPersonalData_Passport_Series, #HolderSkziPersonalData_Passport_Number"
            ).inputmask({
                mask: "*",
                repeat: 32,
                autoUnmask: true,
            });

            // Необходимые манипуляции с атрибутами для валидации
            ForeignValidationsAttributs(
                "#HolderSkziPersonalData_Passport_Series",
                "#HolderSkziPersonalData_Passport_Number"
            );

            // Показываем поле "Дата окончания"
            $(".js-foreigner-passport-holder").removeClass("hidden");

            // Убираем атрибут указывающий на обязательное заполнение
            $("#HolderSkziPersonalData_Passport_IssueId").prop(
                "required",
                false
            );

            $(".js-passport-issueid-hidden").addClass("hidden");
        }

        // Изменяем форму сохранения персональных данных,
        // для иностранца руководителя (Юр. лицо)
        function ForeignerChiefLegal() {
            // Меняем маски на серию и номер паспорта
            $(
                "#DirectorPersonalData_Passport_Series, #DirectorPersonalData_Passport_Number"
            ).inputmask({
                mask: "*",
                repeat: 32,
                autoUnmask: true,
            });

            // Необходимые манипуляции с атрибутами для валидации
            ForeignValidationsAttributs(
                "#DirectorPersonalData_Passport_Series",
                "#DirectorPersonalData_Passport_Number"
            );

            // Показываем поле "Дата окончания"
            $(".js-foreigner-passport-director").removeClass("hidden");

            // Убираем атрибут указывающий на обязательное заполнение
            $("#HolderSkziPersonalData_Passport_IssueId").prop(
                "required",
                false
            );

            $(".js-passport-issueid-hidden").addClass("hidden");
        }

        // Изменяем форму сохранения персональных данных,
        // для иностранца руководителя (ИП)
        function ForeignerChiefBusinessman() {
            // Меняем маски на серию и номер паспорта
            $(
                "#IpPersonalData_Passport_Series, #IpPersonalData_Passport_Number"
            ).inputmask({
                mask: "*",
                repeat: 32,
                autoUnmask: true,
            });

            // Необходимые манипуляции с атрибутами для валидации
            ForeignValidationsAttributs(
                "#IpPersonalData_Passport_Series",
                "#IpPersonalData_Passport_Number"
            );

            // Показываем поле "Дата окончания"
            $(".js-foreigner-passport-director").removeClass("hidden");

            // Убираем атрибут указывающий на обязательное заполнение
            $("#HolderSkziPersonalData_Passport_IssueId").prop(
                "required",
                false
            );

            $(".js-passport-issueid-hidden").addClass("hidden");
        }

        // Меняем свойства формы сохранения персональных данных физ. лица
        // Если физ. лицо иностранный гражданин
        function ForeignerFiz() {
            // Меняем маски на серию и номер паспорта
            $(
                "#FizPersonalData_Passport_Series, #FizPersonalData_Passport_Number"
            ).inputmask({
                mask: "*",
                repeat: 32,
                autoUnmask: true,
            });

            // Необходимые манипуляции с атрибутами для валидации
            ForeignValidationsAttributs(
                "#FizPersonalData_Passport_Series",
                "#FizPersonalData_Passport_Number"
            );

            // Показываем поле "Дата окончания"
            $(".js-foreigner-passport-holder").show();

            // Убираем атрибут указывающий на обязательное заполнение
            $(
                "#FizPersonalData_BirthPlace, #FizPersonalData_Passport_DateOfIssue, #FizPersonalData_Passport_IssueId, #FizPersonalData_Passport_Issued, #FizPersonalData_Passport_Series"
            ).prop("required", false);
        }

        // Изменяем форму сохранения персональных данных,
        // для не иностранца владельца сертификата
        function NotForeignerHolderSkzi() {
            // Меняем маски на серию и номер паспорта
            $("#HolderSkziPersonalData_Passport_Series").inputmask({
                mask: "9999",
                autoUnmask: true,
            });

            $("#HolderSkziPersonalData_Passport_Number").inputmask({
                mask: "999999",
                autoUnmask: true,
            });

            // Необходимые манипуляции с атрибутами для валидации
            NotForeignValidationsAttributs(
                "#HolderSkziPersonalData_Passport_Series",
                "#HolderSkziPersonalData_Passport_Number"
            );

            // Скрываем поле "Дата окончания"
            $(".js-foreigner-passport-holder").addClass("hidden");

            $(".js-passport-issueid-hidden").removeClass("hidden");

            // Возвращаем атрибут указывающий на обязательное заполнение
            $("#HolderSkziPersonalData_Passport_IssueId").prop(
                "required",
                true
            );
        }

        // Изменяем форму сохранения персональных данных,
        // для не иностранца руководителя (Юр. лицо)
        function NotForeignerChiefLegal() {
            // Меняем маски на серию и номер паспорта
            $("#DirectorPersonalData_Passport_Series").inputmask({
                mask: "9999",
                autoUnmask: true,
            });

            $("#DirectorPersonalData_Passport_Number").inputmask({
                mask: "999999",
                autoUnmask: true,
            });

            // Необходимые манипуляции с атрибутами для валидации
            NotForeignValidationsAttributs(
                "#DirectorPersonalData_Passport_Series",
                "#DirectorPersonalData_Passport_Number"
            );

            // Скрываем поле "Дата окончания"
            $(".js-foreigner-passport-director").addClass("hidden");

            $(".js-passport-issueid-hidden").removeClass("hidden");

            // Возвращаем атрибут указывающий на обязательное заполнение
            $("#HolderSkziPersonalData_Passport_IssueId").prop(
                "required",
                true
            );
        }

        // Изменяем форму сохранения персональных данных,
        // для не иностранца руководителя (ИП)
        function NotForeignerChiefBusinessman() {
            // Меняем маски на серию и номер паспорта
            $("#IpPersonalData_Passport_Series").inputmask({
                mask: "9999",
                autoUnmask: true,
            });

            $("#IpPersonalData_Passport_Number").inputmask({
                mask: "999999",
                autoUnmask: true,
            });

            // Необходимые манипуляции с атрибутами для валидации
            NotForeignValidationsAttributs(
                "#IpPersonalData_Passport_Series",
                "#IpPersonalData_Passport_Number"
            );

            // Скрываем поле "Дата окончания"
            $(".js-foreigner-passport-director").addClass("hidden");

            $(".js-passport-issueid-hidden").removeClass("hidden");

            // Возвращаем атрибут указывающий на обязательное заполнение
            $("#HolderSkziPersonalData_Passport_IssueId").prop(
                "required",
                true
            );
        }

        // Меняем свойства формы сохранения персональных данных физ. лица
        // Если физ. лицо гражданин РФ
        function NotForeignerFiz() {
            // Меняем маски на серию и номер паспорта
            $("#FizPersonalData_Passport_Series").inputmask({
                mask: "9999",
                autoUnmask: true,
            });

            $("#FizPersonalData_Passport_Number").inputmask({
                mask: "999999",
                autoUnmask: true,
            });

            // Необходимые манипуляции с атрибутами для валидации
            NotForeignValidationsAttributs(
                "#FizPersonalData_Passport_Series",
                "#FizPersonalData_Passport_Number"
            );

            // Скрываем поле "Дата окончания"
            $(".js-foreigner-passport-holder").hide();

            // Возвращаем атрибут указывающий на обязательное заполнение
            $(
                "#FizPersonalData_BirthPlace, #FizPersonalData_Passport_DateOfIssue, #FizPersonalData_Passport_IssueId, #FizPersonalData_Passport_Issued, #FizPersonalData_Passport_Series"
            ).prop("required", true);
        }

        function ForeignerHolderUC() {
            // Меняем маски на серию и номер паспорта
            $(
                "#ProfileDifference_CertificateHolder_Passport_Series_Value, #ProfileDifference_CertificateHolder_Passport_Number_Value"
            ).inputmask({
                mask: "*",
                repeat: 32,
                autoUnmask: true,
            });

            // Необходимые манипуляции с атрибутами для валидации
            ForeignValidationsAttributs(
                "#ProfileDifference_CertificateHolder_Passport_Series_Value",
                "#ProfileDifference_CertificateHolder_Passport_Number_Value"
            );

            // Показываем поле "Дата окончания"
            $(".js-foreigner-passport-director").removeClass("hidden");

            // Убираем атрибут обязательного поля
            $(
                "#ProfileDifference_CertificateHolder_Passport_IssuerId_Value"
            ).prop("required", false);

            // Скрываем поле
            $(".js-passport-issueid-hidden-uc").addClass("hidden");
        }

        function NotForeignerHolderUC() {
            // Меняем маски на серию и номер паспорта
            $(
                "#ProfileDifference_CertificateHolder_Passport_Series_Value"
            ).inputmask({
                mask: "9999",
                autoUnmask: true,
            });

            $(
                "#ProfileDifference_CertificateHolder_Passport_Number_Value"
            ).inputmask({
                mask: "999999",
                autoUnmask: true,
            });

            // Необходимые манипуляции с атрибутами для валидации
            NotForeignValidationsAttributs(
                "#ProfileDifference_CertificateHolder_Passport_Series_Value",
                "#ProfileDifference_CertificateHolder_Passport_Number_Value"
            );

            // Показываем поле "Дата окончания"
            $(".js-foreigner-passport-director").addClass("hidden");

            // Убираем атрибут обязательного поля
            $(
                "#ProfileDifference_CertificateHolder_Passport_IssuerId_Value"
            ).prop("required", true);

            // Показываем поле
            $(".js-passport-issueid-hidden-uc").removeClass("hidden");
        }

        // Обновление свойств формы персональных данных
        function UpdateFormPersonalData(isForeignCitizen) {
            if (isForeignCitizen.selectHolderSkzi !== "RUS") {
                ForeignerHolderSkzi();

                if (
                    isForeignCitizen.isCheckedToDirector !== "RUS" ||
                    isForeignCitizen.selectDirector !== "RUS"
                ) {
                    ForeignerChiefLegal();
                } else {
                    NotForeignerChiefLegal();
                }

                if (
                    isForeignCitizen.isCheckedToIpPersonal !== "RUS" ||
                    isForeignCitizen.selectIp !== "RUS"
                ) {
                    ForeignerChiefBusinessman();
                } else {
                    NotForeignerChiefBusinessman();
                }
            } else {
                NotForeignerHolderSkzi();

                if (
                    isForeignCitizen.isCheckedToDirector !== "RUS" ||
                    isForeignCitizen.selectDirector === "RUS"
                ) {
                    NotForeignerChiefLegal();
                } else {
                    ForeignerChiefLegal();
                }

                if (
                    isForeignCitizen.isCheckedToIpPersonal !== "RUS" ||
                    isForeignCitizen.selectIp === "RUS"
                ) {
                    NotForeignerChiefBusinessman();
                } else {
                    ForeignerChiefBusinessman();
                }
            }

            // Изменяем форму ввода персональных данных в карточках менеджера УЦ
            if (isForeignCitizen.selectHolderUC === "RUS") {
                NotForeignerHolderUC();
            } else {
                ForeignerHolderUC();
            }

            // Изменяем форму ввода персональных данных для физ. лица
            if (isForeignCitizen.selectFiz === "RUS") {
                NotForeignerFiz();
            } else {
                ForeignerFiz();
            }
        }

        // Проверка не сохраненых изменений при переключении вкладки.
        $('a[data-toggle="tab"]').on("hide.bs.tab", function (e) {
            // Получаем ссылку на переключаемую вкладку
            // При нажатии на вкладку сохраняем её адрес и передаём в кнопку "Перейти без сохранения" в модальном окне
            var savePanelUrl = $(e.relatedTarget).attr("href");

            if (changed) {
                showUnsavedAlert();

                $(".js-dont-save").attr("data-tab-link", savePanelUrl);

                return false;
            }
        });

        // При нажатии на кнопку "Перейти без сохранения" скрываем модальное окно
        // и активируем необходимую вкладку
        $(".js-dont-save").on("click", function (e) {
            e.preventDefault();

            hideUnsavedAlert();

            var link = $(this).attr("data-tab-link");

            // активируем вкладку
            $('[href="' + link + '"]')
                .closest("li")
                .addClass("active")
                .siblings()
                .removeClass("active");

            // активируем контент вкладки
            $(link).addClass("active in").siblings().removeClass("active in");

            changed = false;
        });
    });
}

// Отображение всплывающего окна предупреждающего о наличии не сохраненных изменений на вкладке.
function showUnsavedAlert() {
    $("#wantToSave").modal("show");
}

// Сокрытие всплывающего окна предупреждающего о наличии не сохраненных изменений на вкладке.
function hideUnsavedAlert() {
    $("#wantToSave").modal("hide");
}

// Установка значения ИНН для поля с конкретным селектором
function setInnForSelector(selector, inn) {
    var $inn = $(selector);

    $inn.val(inn);

    if ($inn.inputmask("isComplete")) {
        $inn.trigger("complete");
    }
}

// Проверка строки на NULL и пустоту
function isNullOrEmpty(string) {
    return !string || !string.trim();
}

// Копирование значений полей
// Используем при копировании секций адресов и персональных данных
function setFieldValues(data) {
    Object.keys(data).forEach(function (item) {
        copyFieldValue(item, data[item]);
    });
}

// Копирование значения поля в другое поле
function copyFieldValue(to, from) {
    var $to = $(to);
    var $from = $(from);

    if ($to.is(":checkbox")) {
        // Чекбоксам выставляем checked
        $to.prop("checked", $from.is(":checked"));
    } else {
        // Обычным полям выставляем новое значение
        $to.val($from.val());
    }
}

/////////////////////////////////
// Заполнение данных формы по ИНН
function getEGRNdata(inn) {
    if (!inn) {
        alertify.error("Отсутствует ИНН для загрузки данных");
        return;
    }

    // URL загрузки информации по ИНН
    var root = $("base")[0].href || "/";
    var url = root + "Egrn/GetInfoFromInn";

    var data = {
        inn: inn,
        __RequestVerificationToken: $(
            '[name="__RequestVerificationToken"]'
        ).val(),
    };

    $.post(url, data).then(function (response) {
        if (!response) {
            alertify.error("Ошибка при получении информации по ИНН");
            return;
        }

        // ЮР.ЛИЦО
        if (!isNullOrEmpty(response.ShortName)) {
            $("#LegalData_Name").val(response.ShortName);
        }

        // Полное наименование
        if (!isNullOrEmpty(response.FullName)) {
            $("#LegalData_FullName").val(response.FullName);
        }

        // ФИО руководителя, держателя, ответственного
        if (!isNullOrEmpty(response.ChiefLastName)) {
            $(
                "#DirectorPersonalData_Surname, #HolderSkziPersonalData_Surname, #IpPersonalData_Surname"
            ).val(response.ChiefLastName);
        }
        if (!isNullOrEmpty(response.ChiefFirstName)) {
            $(
                "#DirectorPersonalData_Name, #HolderSkziPersonalData_Name, #IpPersonalData_Name"
            ).val(response.ChiefFirstName);
        }

        if (!isNullOrEmpty(response.ChiefPatronymic)) {
            $(
                "#DirectorPersonalData_Patronymic, #HolderSkziPersonalData_Patronymic, #IpPersonalData_Patronymic"
            ).val(response.ChiefPatronymic);
        }

        // КПП
        if (!isNullOrEmpty(response.Kpp)) {
            $("#LegalData_KPP").val(response.Kpp);
        }

        // ОГРНИП теперь приходит в ОГРН
        if (!isNullOrEmpty(response.Ogrn)) {
            $("#OGRN_ЮЛ, #OGRN_ИП").val(response.Ogrn);
        }

        // Юр. и факт. адрес
        if (!isNullOrEmpty(response.Country)) {
            $("#UrAddressModel_Country, #FactAddressModel_Country").val(
                response.Country
            );
        }

        if (!isNullOrEmpty(response.Region)) {
            $("#UrAddressModel_Region, #FactAddressModel_Region").val(
                response.Region
            );
        }

        if (!isNullOrEmpty(response.City)) {
            $("#UrAddressModel_Locality, #FactAddressModel_Locality").val(
                response.City
            );
        }

        var address = "";

        if (!isNullOrEmpty(response.Street)) {
            address += response.Street;
        }

        if (!isNullOrEmpty(response.House)) {
            address += " " + response.House;
        }

        if (!isNullOrEmpty(address)) {
            $("#UrAddressModel_Address1, #FactAddressModel_Address1").val(
                address
            );
        }

        // Должность
        if (!isNullOrEmpty(response.ChiefPosition)) {
            $(
                "#DirectorPersonalData_Position, #HolderSkziPersonalData_Position, #IpPersonalData_Position"
            ).val(response.ChiefPosition);
        }

        // Основания полномочий
        if (!isNullOrEmpty(response.Document)) {
            $(
                "#DirectorPersonalData_ReasonAuthority, #HolderSkziPersonalData_ReasonAuthority, #IpPersonalData_ReasonAuthority"
            ).val(response.Document);
        }
    });
}

//////////////////////////////////////////////////////
// Функции визуализации (RequestWizard) формы заказов

// Функция отображает панель мастера заказов
function showStep(stepIndex) {
    $(".modal-header").addClass("collapse");
    $(".js-step").addClass("collapse");
    $(".js-modal-footer").addClass("collapse");

    $("#header-" + stepIndex).removeClass("collapse");
    $("#" + stepIndex).removeClass("collapse");
    $("#footer-" + stepIndex).removeClass("collapse");
}

// Функция отображения подвала с нужными кнопками
function showStepFooter(stepIndex) {
    $(".js-modal-footer").addClass("collapse");
    $("#footer-" + stepIndex).removeClass("collapse");
}

// Заблокировать кнопки в подвале визарда
function disableFooterButtons(stepIndex) {
    $("#footer-" + stepIndex)
        .find("button")
        .prop("disabled", true);
}

// Заблокировать кнопку создания заказа в подвале визарда
function disableButtonCreateRequest() {
    $("#createNewRequest").prop("disabled", true);
}

// Разблокировать кнопку создания заказа в подвале визарда
function enableButtonCreateRequest() {
    $("#createNewRequest").prop("disabled", false);
}

// Заблокировать кнопку подтверждения заказа в подвале визарда
function disableButtonConfirmRequest() {
    $("#confirmRequest").prop("disabled", true);
}

// Разблокировать кнопку подтверждения заказа в подвале визарда
function enableButtonConfirmRequest() {
    $("#confirmRequest").prop("disabled", false);
}

// Блокирование выбора тарифа и типа лицензии СКЗИ
// в форме формирования заказа
function formSelectDisabled() {
    $("#selectTariffs").prop("disabled", true);
    $("#licenses").prop("disabled", true);
}

// Разблокирование выбора тарифа и типа лицензии СКЗИ
// в форме формирования заказа
function formSelectEnabled() {
    $("#selectTariffs").prop("disabled", false);
    $("#licenses").prop("disabled", false);
}

// Снять блокировку с кнопок в подвале визарда
function enableFooterButtons(stepIndex) {
    $("#footer-" + stepIndex)
        .find("button")
        .prop("disabled", false);
}

// Отобразить индикатор занятости
function showBusyIndicator(message, progress) {
    // Показываем индикатор занятости
    $("#busyIndicator").removeClass("hidden");
    $("#busyText").text(message);

    // Индикация прогресса
    if (progress && progress > -1) {
        $("#busyText").text(progress + "%");
        $("#busyIndicator .progress-bar").attr("aria-valuenow", progress);
        $("#busyIndicator .progress-bar").css("width", progress + "%");
    }
}

// Скрыть индикатор занятости
function hideBusyIndicator() {
    $("#busyIndicator").addClass("hidden");
}

// Валидация адреса доставки
function validateRequestDelivery() {
    var _value = $("#fullAddress").val();
    var _country = $("#country").val();
    var _region = $("#region").val();
    var _area = $("#area").val();
    var _city = $("#city").val();
    var _settlement = $("#settlement").val();
    var _street = $("#street").val();
    var _house = $("#house").val();
    var _postal_code = $("#postal_code").val();

    if (_value == "") {
        throw alertify.error("Не заполнено поле полный адрес");
    }

    if (_country == "") {
        throw alertify.error("Не заполнено поле страна");
    }

    if (_city == "" && _settlement == "") {
        throw alertify.error("Не заполнены поле город или населенный пункт");
    }

    if (_street == "") {
        throw alertify.error("Не заполнено поле улица");
    }

    if (_region == "") {
        throw alertify.error("не заполнено поле регион");
    }

    if (_house == "") {
        throw alertify.error("Не заполнено поле дом");
    }
}

function limitInput(k, obj) {
    switch (k) {
        case "ru":
            obj.value = obj.value.replace(/[^а-яА-ЯёЁ0-9 -]/gi, "");
            break;
        case "en":
            obj.value = obj.value.replace(/[^a-zA-Z0-9 -]/gi, "");
            break;
    }
}
// Конец функций визуализации (RequestWizard) формы заказов
///////////////////////////////////////////////////////////
